import { Link as RouterLink } from "react-router-dom";
import { Text } from "../Text/Text";
import styles from "./Breadcrumbs.module.scss";

export const Breadcrumbs = ({ links }) => {

  return (
    <ul className={styles.BreadcrumbsBlock}>
      <li>
        <RouterLink to={'/'} className={styles.link}>
          <Text style={{textDecoration: "underline"}}>Главная</Text>
        </RouterLink>
      </li>
      {links.slice(0,-1).map((value, key) => {
        return(
          <li key={key}>
            <RouterLink to={value.href}>
              <Text style={{textDecoration: "underline"}}>
                {value.title}
              </Text>
            </RouterLink>
          </li>
        )
      })}
      <li>
        <Text className={styles.BreadcrumbsItem_text}>
          {links.slice(-1)[0].title}
        </Text>
      </li>
    </ul>
  );

};
